import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiCalendar, FiAlertCircle, FiBookOpen, FiUsers, FiClock, FiStar } from "react-icons/fi";
import eventService from "../services/eventService";
import { useApp } from "../context/AppContext";

const TYPE_CONFIG = {
    Holiday: { color: "#dc2626", bg: "#fee2e2", icon: FiAlertCircle },
    Exam: { color: "#7c3aed", bg: "#ede9fe", icon: FiBookOpen },
    Event: { color: "#003b67", bg: "#e8f1f8", icon: FiStar },
    Meeting: { color: "#d97706", bg: "#fef3c7", icon: FiUsers },
    Other: { color: "#6b7280", bg: "#f3f4f6", icon: FiClock },
};

const today = new Date().toISOString().slice(0, 10);

const dayLabel = (dateStr) => {
    if (dateStr === today) return "Today";
    const diff = Math.round(
        (new Date(dateStr) - new Date(today)) / 86400000
    );
    if (diff === 1) return "Tomorrow";
    if (diff < 8) return `In ${diff} days`;
    return dateStr;
};

export default function UpcomingEventsWidget() {
    const { academicYear } = useApp();
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        eventService
            .getUpcoming({ days: 30, academicYear: academicYear?._id || "" })
            .then((res) => setEvents(Array.isArray(res) ? res : []))
            .catch(() => setEvents([]))
            .finally(() => setLoading(false));
    }, [academicYear]);

    return (
        <div className="card" style={{ marginBottom: "1rem" }}>
            <div
                className="card-header"
                style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    cursor: "pointer",
                }}
                onClick={() => navigate("/events")}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                    <FiCalendar size={14} />
                    Upcoming Events
                    {events.length > 0 && (
                        <span style={{ fontSize: 11, background: "var(--primary)", color: "#fff", padding: "1px 7px", borderRadius: 99, fontWeight: 700 }}>
                            {events.length}
                        </span>
                    )}
                </div>
                <span style={{ fontSize: 12, color: "var(--text-muted)", fontWeight: 400 }}>
                    View Calendar →
                </span>
            </div>

            <div className="card-body" style={{ padding: "0.75rem 1.25rem" }}>
                {loading ? (
                    <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Loading…</div>
                ) : events.length === 0 ? (
                    <div style={{ fontSize: 13, color: "var(--text-muted)" }}>
                        No upcoming events in the next 30 days.
                    </div>
                ) : (
                    <div style={{ display: "grid", gap: "0.5rem" }}>
                        {events.slice(0, 5).map((ev) => {
                            const tc = TYPE_CONFIG[ev.type] || TYPE_CONFIG.Other;
                            const Icon = tc.icon;
                            return (
                                <div
                                    key={ev._id}
                                    style={{
                                        display: "flex", gap: "0.65rem", alignItems: "center",
                                        padding: "0.45rem 0",
                                        borderBottom: "1px solid var(--border)",
                                    }}
                                >
                                    <div style={{ width: 28, height: 28, borderRadius: 8, background: tc.bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                        <Icon size={12} color={tc.color} />
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: 13, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                            {ev.title}
                                        </div>
                                        <div style={{ fontSize: 11.5, color: "var(--text-muted)" }}>
                                            <span style={{ color: tc.color, fontWeight: 600 }}>{ev.type}</span>
                                            {ev.isHoliday && (
                                                <span style={{ marginLeft: 5, fontSize: 10, background: "#fee2e2", color: "#dc2626", padding: "1px 5px", borderRadius: 99, fontWeight: 700 }}>Holiday</span>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            fontSize: 11, fontWeight: 700,
                                            color: ev.date === today ? "#dc2626" : "var(--text-muted)",
                                            whiteSpace: "nowrap",
                                            flexShrink: 0,
                                        }}
                                    >
                                        {dayLabel(ev.date)}
                                    </div>
                                </div>
                            );
                        })}
                        {events.length > 5 && (
                            <button
                                className="btn btn-outline btn-sm"
                                style={{ width: "100%", justifyContent: "center", marginTop: "0.25rem" }}
                                onClick={() => navigate("/events")}
                            >
                                + {events.length - 5} more events
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
